export const brightenColor = (hexColor, percent = 20) => {
	const hex = hexColor.replace('#', '');
	const r = parseInt(hex.substring(0, 2), 16);
	const g = parseInt(hex.substring(2, 4), 16);
	const b = parseInt(hex.substring(4, 6), 16);

	const brighten = (value) => {
		const increased = value + ((255 - value) * percent) / 100;
		return Math.min(255, Math.round(increased));
	};

	const newR = brighten(r);
	const newG = brighten(g);
	const newB = brighten(b);

	const toHex = (value) => value.toString(16).padStart(2, '0');
	return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
};
